<script lang="ts">
    import { onMount } from "svelte";
    import { goto } from "$app/navigation";
    import { getAuthToken } from "$lib/stores/auth";
    import { isPageActive } from "$lib/utils/is-page-active";
    import { ProgressBar } from "@prgm/sveltekit-progress-bar";
    import Footer from "$lib/components/navigation/footer.svelte";
    import Navbar from "$lib/components/navigation/navbar.svelte";
    import SectionEventsCategory from "$lib/components/section/Event/section-events-category.svelte";

    export let data: any = [];

    $: queryParams = data.queryParams;
    $: categorySlug = data.categorySlug;
    $: client = data.client;
    $: events = data.events.data;
    $: metaPagination = data.events.meta;
    $: categories = data.categories;
    $: permissions = data.permissions;
    $: currentNamePage = isPageActive("events", client, permissions);
    $: titleName = data.titleName;
        
    const primaryColor = String(data?.permissions?.data?.colors?.primary);

    onMount(async () => {
        let authToken = await getAuthToken();
        if (!authToken && data?.client?.force_user_to_login === 1) {
            goto("/login");
        }
    });
</script>

<svelte:head>
    <title>
        {currentNamePage} ({titleName}) -
        {client?.name}
    </title>
    <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${client?.favicon === null ? "/favicon-32x32.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={`${client?.favicon === null ? "/favicon-96x96.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${client?.favicon === null ? "/favicon-16x16.png" : client?.favicon}`}
    />
</svelte:head>
<Navbar data={client} dataPermission={permissions} />
<ProgressBar color={primaryColor} class="text-[${primaryColor}]" zIndex={100} />
<div id="core">
    <div class="core__inner">
        <!-- MAIN : begin -->
        <main id="main">
            <div class="main__inner">
                <!-- MAIN CONTENT : begin -->
                <div class="main__content">
                    <div class="main__content-wrapper">
                        <div class="main__content-inner">
                            <div class="lsvr-container">
                                <!-- POST ARCHIVE : begin -->
                                <div
                                    class="post-archive lsvr_event-post-page lsvr_event-post-archive lsvr_event-post-archive--grid lsvr_event-post-archive--layout-style-dark"
                                >
                                    <!-- MAIN HEADER : begin -->
                                    <header class="main-header">
                                        <div class="main-header__inner">
                                            <h1 class="font-medium mb-5">
                                                {currentNamePage}
                                            </h1>
                                        </div>
                                    </header>

                                    <SectionEventsCategory
                                        {queryParams}
                                        {categorySlug}
                                        {primaryColor}
                                        data={events}
                                        meta={metaPagination}
                                        {categories}
                                        title={client?.name}
                                        {currentNamePage}
                                        {client}
                                        {permissions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- MAIN CONTENT : begin -->
            </div>
        </main>
        <!-- MAIN : end -->
    </div>
</div>

<Footer data={client} />
